export * as passengersTextModel from './use-passengers-text';
